import { Component, OnInit } from '@angular/core';
import { SharedService } from 'src/app/modules/shared/_services/shared.service';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';

@Component({
  selector: 'app-blog-slider',
  templateUrl: './blog-slider.component.html',
  styleUrls: ['./blog-slider.component.scss']
})
export class BlogSliderComponent implements OnInit {


  isScroll: boolean = true;
  type: string = "";
  slideConfig2: any;
  showInputs: boolean = false; numberOfItems: number = 1;
  containerId: string = "slider-" + Math.random().toString(36).substr(2, 9);
  hideContainer = false;
  topPerformingContainer = 'top-performing-inner-container';
  isLeftVisible: boolean = false;
  isRightVisible: boolean = true;
  blogList: any;
  counts: any;
  baseUrl: any = environment.TENDER.BASE_URL;

  constructor(private router: Router,
    private sharedService: SharedService
  ) {
  }

  ngOnInit(): void {
    const urlSegments = this.router.url.split('/');
    if (urlSegments.length > 2) {
      const slug = urlSegments[2];
      this.loadBlogList('12', slug);
    }
  }

  private loadBlogList(pageSize: string, slug: any): void {
    this.sharedService.getBlogList(pageSize, '1', slug).subscribe(blogList => {
      this.blogList = blogList?.data?.blogDataList;
    });
  }

  onSliderScroll(event: Event) {
    const data = this.sharedService.onScroll(event);
    this.isRightVisible = data?.isRightVisible;
    this.isLeftVisible = data?.isLeftVisible
  }

  scrollSliderDiv(right?: any) {
    this.sharedService.scrollDiv(this.containerId, this.numberOfItems, right);
  }

}
